import { LN_MARKET_SIDEBAR_ALL, LN_MARKET_SIDEBAR_FAVOURITE } from 'locales/constants'

export const tabsList = [
  { id: 'all', title: LN_MARKET_SIDEBAR_ALL },
  { id: 'favourite', title: LN_MARKET_SIDEBAR_FAVOURITE },
]
